import {Translate} from "../../../../hooks/translate.hook";
import {ColumnsType} from "antd/lib/table/interface";
import React from "react";
import {InvoiceDataDocument} from "../../../../models/documents/invoices/invoice-data/invoice.data";
import {Link} from "react-router-dom";
import {DailyStatementsItemStatus} from "../statements-item-status/statements-item-status";
import {DailyStatementItem} from "../../../../models/accounting/daily-statements";
import {PriceValue} from "../../../common/price/price-value";
import Date from "../../../date/date";

export const columnsFactory = (t: Translate, disabled: boolean): ColumnsType<DailyStatementItem> => {
    return [
        {
            title: "ID",
            dataIndex: "id",
            key: "id"
        },
        {
            title: t("TYPE"),
            dataIndex: "type",
            key: "type",
            render: type => t('ACCOUNTING.STATEMENTS.ITEM.TYPE.' + type.toUpperCase())
        },
        {
            title: t("STATUS"),
            dataIndex: "status",
            key: "status",
            render: (status) => <DailyStatementsItemStatus status={status} />
        },
        {
            title: t("CODE"),
            dataIndex: "agent",
            key: "agent",
            render: (agent: any) => <Link to={"/clients/" + agent.number}>{agent.number}</Link>
        },
        {
            title: t("AGENT_TITLE"),
            dataIndex: "agent",
            key: "agent",
            render: (agent: any) => agent.name
        },
        {
            title: t("DOCUMENT_NUMBER"),
            dataIndex: "invoiceDocument",
            key: "invoiceDocument",
            render: (document: InvoiceDataDocument, item) => {
                if (document) {
                    switch (item.type) {
                        case "invoice":
                            return <Link to={"/merged-invoices/" + document.id}>{document.docNumber}</Link>;
                        case "credit_invoice":
                            return <Link to={"/credit-invoices/" + document.id}>{document.docNumber}</Link>;
                        case "free_credit":
                            return <>-</>;
                    }
                }

                return item.invoiceNumber;
            }
        },
        {
            title: 'Ending balance',
            dataIndex: "endingBalance",
            key: "endingBalance",
            render: value => <PriceValue value={value} />
        },
        {
            title: t("ACCOUNTING.STATEMENTS.ITEM.DATE"),
            key: "date",
            render: (_: any, item) => <>
                <Date dateString={item.date} showTime={false} />&nbsp;/&nbsp;
                <Date dateString={item.invoiceDate} showTime={false} />
            </>
        },
        {
            title: t("ACCOUNTING.STATEMENTS.ITEM.SUBTOTAL"),
            key: "subtotal",
            render: (_: any, item) => <>
                <PriceValue value={item.subtotal} />&nbsp;/&nbsp;
                <PriceValue value={item.invoiceSubtotal} />
            </>
        },
        {
            title: t("ACCOUNTING.STATEMENTS.ITEM.TAX"),
            key: "vat",
            render: (_: any, item) => <>
                <PriceValue value={item.tax} />&nbsp;/&nbsp;
                <PriceValue value={item.invoiceVat} />
            </>
        },
        {
            title: t("ACCOUNTING.STATEMENTS.ITEM.GRAND_TOTAL"),
            key: "grandTotal",
            render: (_: any, item) => <>
                <PriceValue value={item.grandTotal} />&nbsp;/&nbsp;
                <PriceValue value={item.invoiceGrandTotal} />
            </>
        }
    ];
}